var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gallery d-flex justify-content-between",class:_vm.custom_class},_vm._l((_vm.items),function(item,i){return _c('a',{key:i,staticClass:"glightboxTest",style:({ width: _vm.itemsW, height: _vm.itemsH, margin: _vm.itemsMargin }),attrs:{"href":item.src}},[_c('ImageBox',{attrs:{"item":item}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }